<template>
  <input
    ref="input"
    type="text"
    v-bind:id="this.id"
    v-bind:name="this.name"
    v-bind:style="this.cssStyle"
    v-bind:class="this.cssClass"
  />
</template>
<script>
export default {
  props: {
    refObj: [String, Number, Object],
    cssStyle: String,
    cssClass: {
      type: String,
      default: "form-control"
      //  form-control-sm
    },
    id: {
      type: String,
      required: true
    },
    name: String,
    value: String
  },
  mounted: function() {
    var self = this;
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>'
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>'
      };
    }
    $(this.$refs.input).datepicker({
      rtl: KTUtil.isRTL(),
      todayHighlight: true,
      orientation: "bottom left",
      templates: arrows
    });
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// App/Shared/Datepicker.vue